import { render, staticRenderFns } from "./VBtn.vue?vue&type=template&id=2613f44b&scoped=true&"
import script from "./VBtn.vue?vue&type=script&lang=js&"
export * from "./VBtn.vue?vue&type=script&lang=js&"
import style0 from "./VBtn.vue?vue&type=style&index=0&id=2613f44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613f44b",
  null
  
)

export default component.exports